import React, { useState, useMemo } from 'react';
import styles from './Avatar.module.css';

const Avatar = ({
    src,
    name,
    size = 80,
    className = '',
    alt = '',
    fontSize
}) => {
    const [imageError, setImageError] = useState(false);

    // Generate initials from name (e.g. "João Silva" -> "JS")
    const initials = useMemo(() => {
        if (!name) return '?';
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) {
            return parts[0].substring(0, 2).toUpperCase();
        }
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }, [name]);

    // Generate a consistent color based on the name string
    const backgroundColor = useMemo(() => {
        const colors = [
            '#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5',
            '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50',
            '#8BC34A', '#CDDC39', '#FFC107', '#FF9800', '#FF5722',
            '#795548', '#607D8B'
        ];

        let hash = 0;
        const str = name || 'default';
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % colors.length;
        return colors[index];
    }, [name]);

    const containerStyle = {
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: !src || imageError ? backgroundColor : undefined,
        fontSize: fontSize || `${size * 0.4}px`, // Default font size is 40% of avatar size
    };

    return (
        <div
            className={`${styles.avatar_container} ${className}`}
            style={containerStyle}
            title={name}
        >
            {src && !imageError ? (
                <img
                    src={src}
                    alt={alt || name}
                    className={styles.avatar_image}
                    onError={() => setImageError(true)}
                />
            ) : (
                <span className={styles.avatar_initials}>
                    {initials}
                </span>
            )}
        </div>
    );
};

export default Avatar;
